import { __exportAll } from "../../_virtual/_rolldown/runtime.js";
import { DialogBackdrop } from "../dialog/backdrop.js";
import { DialogPopup } from "../dialog/popup.js";
import { ErrorDialogClose } from "./close.js";
import { ErrorDialogDescription } from "./description.js";
import { ErrorDialogRoot } from "./root.js";
import { ErrorDialogTitle } from "./title.js";
//#region src/ui/error-dialog/index.parts.ts
var index_parts_exports = /* @__PURE__ */ __exportAll({
	Backdrop: () => DialogBackdrop,
	Close: () => ErrorDialogClose,
	Description: () => ErrorDialogDescription,
	Popup: () => DialogPopup,
	Root: () => ErrorDialogRoot,
	Title: () => ErrorDialogTitle
});
//#endregion
export { DialogBackdrop as Backdrop, ErrorDialogClose as Close, ErrorDialogDescription as Description, DialogPopup as Popup, ErrorDialogRoot as Root, ErrorDialogTitle as Title, index_parts_exports };

//# sourceMappingURL=index.parts.js.map